<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jhhVkB/tc-custom/9781459242043.jpg?1705026902636" alt="This image is the cover for the book Daughter's Story, It Happened in Comfort Cove"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daughter's Story, It Happened in Comfort Cove
      </h1>
      <p class="bookDescription body article font2">
        <i>You can't change the past but you can </i>choose<i> the future!</i><br/><br/><i>Twenty-five years ago</i> Emma Sanderson's life was completely overturned. Her baby sister was kidnapped,  right there in Comfort Cove, and her family fell apart.<br/><br/><i>Now</i> Emma lives quietly, cautiously. Until suddenly  she finds out that the cold case involving her sister's disappearance has been reopened. Then, she ends her engagementand meets another man. Chris Talbot shares her intense unexpected attraction, and their  hours together mean more than anything she's ever experienced.<br/><br/>Despite that, she's uncertain about a relationship with him. He's a man in a dangerous profession, a man who makes his living from the sea, and there are reasons, good reasons, for Emma to keep her distance. But that night could have <i>lasting</i> consequences.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Taylor Quinn
      </h2>
      
      <p class="authorDescription body article"> Tara Taylor Quinn, is a&#160;<I>USA Today</I>&ndash;bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn&rsquo;s novels have received critical acclaim, including the 2008 National Reader&rsquo;s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including&#160;<I>CBS Sunday Morning</I>. For additional offers, news, and contests, visit the author at tarataylorquinn.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bfb91ffe